import { MutationTree } from 'vuex';
import { BannerStandOrdersState, BannerStandOrdersMutations } from './types';
import BannerStandOrder from './banner-stand-order';
import { ListStatus } from '@/store/types';

export const mutations: MutationTree<BannerStandOrdersState> = {
  [BannerStandOrdersMutations.SET_LIST](state, items: BannerStandOrder[]) {
    state.list = items;
  },

  [BannerStandOrdersMutations.SET_LIST_STATUS](state, status: ListStatus) {
    state.listStatus = status;
  },

  [BannerStandOrdersMutations.SET_LIST_PAGINATION](state, pagination: { currentPage: number; lastPage: number; total: number }) {
    state.listPagination = pagination;
  },

  [BannerStandOrdersMutations.SET_CURRENT](state, order: BannerStandOrder | null) {
    state.current = order;
  },
};

export default mutations;
